import { useFlag } from '@/services/featureFlags';

export function useTranslateProofreadAccess() {
    const { visible, enabled } = useFlag<{ visible: boolean; enabled: boolean }>('translations_proofread_enabled', {
        visible: true,
        enabled: false,
    });

    return {
        proofreadVisible: visible,
        proofreadEnabled: enabled,
    };
}
